import Vue from 'vue'
import Vuex from 'vuex'
import { Howl, Howler } from 'howler'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    numScenes: 7,
    currentScene: 1,
    beginButton: true,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    isShakerPlaying: false,
    isVocalsPlaying: false,
    isWalkingStickPlaying: false,
    isHandClapPlaying: false,
    isFootStompPlaying: false,
    audio: {
      scene1: new Howl({
        src: ['audio/scene-1.mp3'],
        html5: true
      }),
      scene2: new Howl({
        src: ['audio/scene-2.mp3'],
        html5: true
      }),
      scene3: new Howl({
        src: ['audio/scene-3.mp3'],
        html5: true
      }),
      scene4: new Howl({
        src: ['audio/scene-4.mp3'],
        html5: true
      }),
      scene5: new Howl({
        src: ['audio/scene-5.mp3'],
        html5: true
      }),
      scene6: new Howl({
        src: ['audio/scene-6.mp3'],
        html5: true
      }),
      shaker: new Howl({
        src: ['audio/mixer-shaker.mp3'],
        html5: true,
        loop: true
      }),
      vocals: new Howl({
        src: ['audio/mixer-vocals.mp3'],
        html5: true,
        loop: true
      }),
      walkingStick: new Howl({
        src: ['audio/mixer-walking-stick.mp3'],
        html5: true,
        loop: true
      }),
      handClap: new Howl({
        src: ['audio/mixer-hand-clap.mp3'],
        html5: true,
        loop: true
      }),
      footStomp: new Howl({
        src: ['audio/mixer-foot-stomp.mp3'],
        html5: true,
        loop: true
      }),
    }
  },
  mutations: {
    SET_CURRENT_SCENE (state, payload) {
      state.currentScene = payload
    },
    PREVIOUS_SCENE (state) {
      state.currentScene--
    },
    NEXT_SCENE (state) {
      state.currentScene++
    },
    HIDE_BEGIN_BUTTON (state) {
      state.beginButton = false
    },
    MUTE (state) {
      state.muted = true
    },
    UNMUTE (state) {
      state.muted = false
    },
    RESET_TRACK_TIME (state) {
      state.trackTime = 0
    },
    RESET_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5
      }, 500)
    },
    CLEAR_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
    },
    PLAY_SHAKER (state) {
      state.audio.shaker.play()
      state.isShakerPlaying = true
    },
    STOP_SHAKER (state) {
      state.audio.shaker.stop()
      state.isShakerPlaying = false
    },
    PLAY_VOCALS (state) {
      state.audio.vocals.play()
      state.isVocalsPlaying = true
    },
    STOP_VOCALS (state) {
      state.audio.vocals.stop()
      state.isVocalsPlaying = false
    },
    PLAY_WALKING_STICK (state) {
      state.audio.walkingStick.play()
      state.isWalkingStickPlaying = true
    },
    STOP_WALKING_STICK (state) {
      state.audio.walkingStick.stop()
      state.isWalkingStickPlaying = false
    },
    PLAY_HAND_CLAP (state) {
      state.audio.handClap.play()
      state.isHandClapPlaying = true
    },
    STOP_HAND_CLAP (state) {
      state.audio.handClap.stop()
      state.isHandClapPlaying = false
    },
    PLAY_FOOT_STOMP (state) {
      state.audio.footStomp.play()
      state.isFootStompPlaying = true
    },
    STOP_FOOT_STOMP (state) {
      state.audio.footStomp.stop()
      state.isFootStompPlaying = false
    }
  },
  actions: {
    begin ({ commit, dispatch }) {
      commit('HIDE_BEGIN_BUTTON')
      dispatch('playAudioByScene')
    },
    previousScene ({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit('PREVIOUS_SCENE')
      }
      dispatch('playAudioByScene')
    },
    nextScene ({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit('NEXT_SCENE')
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      dispatch('playAudioByScene')
    },
    toggleMute ({ state, commit }) {
      if (state.muted) {
        Howler.mute(false)
        commit('UNMUTE')
      } else {
        Howler.mute(true)
        commit('MUTE')
      }
    },
    stopAllAudio ({ state, commit }) {
      Object.keys(state.audio).forEach((key) => {
        state.audio[key].stop()
      })
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    playAudioByScene ({ state, commit, dispatch }) {
      dispatch('stopAllAudio')
      if (typeof state.audio[`scene${state.currentScene}`] !== 'undefined') {
        state.audio[`scene${state.currentScene}`].play()
        commit('RESET_TRACK_INTERVAL')
        commit('RESET_TRACK_TIME')
      }
    },
    playAudioByName ({ state }, name) {
      if (typeof state.audio[name] !== 'undefined') {
        state.audio[name].play()
      }
    },
    stopMixer ({ commit }) {
      commit('STOP_SHAKER')
      commit('STOP_VOCALS')
      commit('STOP_WALKING_STICK')
      commit('STOP_HAND_CLAP')
      commit('STOP_FOOT_STOMP')
    }
  }
})

export default store
